module.exports = __webpack_public_path__ + "img/dogecoin-logo.78d7ead6.svg";